import { render, staticRenderFns } from "./VariableDetails.vue?vue&type=template&id=0fae0d94&"
import script from "./VariableDetails.vue?vue&type=script&lang=js&"
export * from "./VariableDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports